import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Spinner,
    Alert,
    Row,
    Col,
    FormFeedback
} from 'reactstrap';
import { updateMachine } from './redux/action';
import { fetchCompanyList } from 'components/companyList/redux/dispatcher';
import { fetchOilList } from 'components/oilList/redux/dispatcher';
import { updateMachineById } from './redux/dispatcher';
import { fetchFluidHandlerList } from 'commonRedux/getFluidHandler/dispatcher';
import { fetchOilByCompanyId } from 'commonRedux/getOilByCompanyId/dispatcher';
import { errorOilByCompany } from 'commonRedux/getOilByCompanyId/action';

function UpdateViewMachine({ args, isViewOnly, data, setIsUpdate, setIsViewOnly, searchQuery, currentPage, rowsPerPage }) {
    const oilList = useSelector((state) => state.oilListByCompanyReducer) || [];
    const companyListData = useSelector((state) => state?.companyListReducer)
    const fluidHandlerData = useSelector((state) => state?.fluidHandlerReducer)
    const dispatch = useDispatch()
    const [machineName, setMachineName] = useState(data?.machine_name);
    const [machineModel, setMachineModel] = useState(data?.model);
    const [machineSize, setMachineSize] = useState(data?.size);
    const [machineNumber, setMachineNumber] = useState(data?.machine_number);
    const [tankSize, setTankSize] = useState(data?.tank_size);
    const [companyName, setCompanyName] = useState(data?.companyId);
    const [currentUser, setCurrentUser] = useState('');
    const [companyList, setcompanyList] = useState(companyListData?.data?.data || []);
    const [userList, setUserList] = useState(fluidHandlerData?.fluidHandlerList?.result || []);
    const [concentrationParameters, setConcentrationParameters] = useState('lower');
    const [modal, setModal] = useState(true);
    const [status, setStatus] = useState(data?.status === 'active' ? true : false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [selectedUsers, setSelectedUsers] = useState(data?.user_ids || []);
    const [coolantList, setCoolantList] = useState([]);
    const [coolant, setCoolant] = useState(data?.oil_machine_info[0]?.oil_id);
    const [maintanceOilList, setMaintanceOilList] = useState([]);
    const [maintanceOil, setMaintanceOil] = useState(data?.oil_machine_info[1]?.oil_id);
    const [hydraulicOilList, setHydraulicOilList] = useState([]);
    const [hydraulicOil, setHydraulicOil] = useState(data?.oil_machine_info[2]?.oil_id);
    const [searchData, setSearchData] = useState('')
    const [filteredUser, setFilteredUser] = useState(userList);
    const [errorMessage, setErrorMessage] = useState('');
    const [formError, setFormError] = useState({
        machineName: false,
        model: false,
        machineSize: false,
        machineNumber: false,
        maintanceOil: false,  //optional
        hydraulicOil: false, //optional
        coolantOil: false,
        tankSize: false,
        selectedCompany: false,
        selectedUsers: false,
        lowerCp: false,
        higherCp: false,
        oilTopupRatio: false,
        waterUsed: false,


    });
    const [lowerCP, setLowerCP] = useState(data?.conc_limit_lower);
    const [higherCP, setHigherCP] = useState(data?.conc_limit_higher);

    const [perCentageOilTopRatio, setPercentageOilTopRatio] = useState(data?.oil_topup_ratio);
    const [waterUsed, setWeaterUsed] = useState(data?.water);

    // Handle Modal (Show or not)
    const toggleModal = () => {
        setModal(!modal);
        setError('');
        setLoading(false);
        setMachineName('');
        setMachineModel('');
        setCurrentUser('')
        setMachineSize('')
        setTankSize('')
        setCompanyName('');
        setMachineNumber('');
        setConcentrationParameters('lower')
        setError('')
        setFormError({
            machineName: false,
            model: false,
            machineSize: false,
            machineNumber: false,
            maintanceOil: false,  //optional
            hydraulicOil: false, //optional
            coolantOil: false,
            tankSize: false,
            selectedCompany: false,
            selectedUsers: false,
            lowerCp: false,
            higherCp: false,
            oilTopupRatio: false,
            waterUsed: false,

        })
        setIsUpdate(false);
        setIsViewOnly(false);

    };

    const handleStatusChange = () => setStatus(!status);


    useEffect(() => {
        setcompanyList(companyListData?.data?.data || [])
    }, [companyListData])
    useEffect(() => {
        dispatch(fetchCompanyList());
        dispatch(fetchFluidHandlerList())
    }, [dispatch]);

    useEffect(() => {
        if (companyName) {
            dispatch(fetchOilByCompanyId(companyName))
        } else {
            dispatch(errorOilByCompany(''))
        }
    }, [companyName])
    useEffect(() => {
        setUserList(fluidHandlerData?.fluidHandlerList?.result || [])
        setFilteredUser(fluidHandlerData?.fluidHandlerList?.result || [])
    }, [fluidHandlerData])

    useEffect(() => {

        if (oilList?.oilByCompany) {
            const coolants = oilList.oilByCompany.filter(oil => oil?.oil_type === 'Coolant');
            const maintenanceOils = oilList.oilByCompany.filter(oil => oil?.oil_type === 'Maintenance');
            const hydraulicOils = oilList.oilByCompany.filter(oil => oil?.oil_type === 'Hydraulic');

            setCoolantList(coolants);
            setMaintanceOilList(maintenanceOils);
            setHydraulicOilList(hydraulicOils);
        }
    }, [oilList]);

    // Handle Form
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (!coolant || selectedUsers.length == 0) {
            setFormError({
                coolantOil: formError.coolantOil || !coolant,
                selectedUsers: formError.selectedUsers || selectedUsers.length == 0,
            });
            setErrorMessage('Please correct the errors in the form.');
            setLoading(false);

            return;
        }
        setErrorMessage('');
        setError('');
        try {

            const machineData = {
                "id": data?.machine_id,
                "name": machineName,
                "model": machineModel,
                "machine_size": machineSize,
                "tank_size": tankSize,
                "machine_number": machineNumber,
                "company": companyName,
                "oil_topup_ratio": perCentageOilTopRatio,
                "conc_limit_lower": lowerCP,
                "conc_limit_higher": higherCP,
                "water_used": waterUsed,
                "uuid": selectedUsers,
                "coolant_oil": parseInt(coolant, 10),
                "maintenance_oil": parseInt(maintanceOil, 10),
                "hydraulic_oil": parseInt(hydraulicOil, 10),
                "status": status ? 'active' : 'inactive',
                "company_id": companyName
            };
            console.log('machine data is', machineData)
            dispatch(updateMachineById(machineData, toggleModal, searchQuery, currentPage, rowsPerPage))

        } catch (err) {
            setError('Error adding machine. Please try again.');
        } finally {
            // toggleModal();
            setLoading(false)
        }
    };

    const handleConcentrationChange = (value) => {
        setConcentrationParameters(value);
    };

    const handleUserSelection = (e) => {
        const value = e.target.value;
        setSelectedUsers(prevState =>
            prevState.includes(value)
                ? prevState.filter(item => item !== value)
                : [...prevState, value]
        );
    }
    const handleUserSearch = (e) => {
        const value = e.target.value;
        setSearchData(value);

        const filteredData = userList.filter(item =>
            item?.first_name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredUser(filteredData);
    }

    //Regex
    const validateMachineName = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, machineName: false }));
            return;
        }
        const regex = /^.{2,20}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, machineName: !isValid }));
    };

    const validateMachineSize = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, machineSize: false }));
            return;
        }
        const regex = /^.{2,15}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, machineSize: !isValid }));
    };

    const validateMachineNumber = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, machineNumber: false }));
            return;
        }
        const regex = /^.{1,15}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, machineNumber: !isValid }));
    };

    const validateTankSize = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, tankSize: false }));
            return;
        }
        const regex = /^.{2,15}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, tankSize: !isValid }));
    };
    const validateModel = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, model: false }));
            return;
        }
        const regex = /^.{2,15}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, model: !isValid }));
    };

    const validateLowerCP = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, lowerCp: false }));
            return;
        }
        // Prevent input if more than 2 digits
        if (value.length > 2) {
            e.target.value = value.slice(0, 2);
            setLowerCP(value.slice(0, 2));
            return;
        }
        const regex = /^\d{1,2}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, lowerCp: !isValid }));
    };

    const validateHigherCP = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, higherCp: false }));
            return;
        }
        // Prevent input if more than 2 digits
        if (value.length > 2) {
            e.target.value = value.slice(0, 2);
            setHigherCP(value.slice(0, 2));
            return;
        }

        const regex = /^\d{1,2}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, higherCp: !isValid }));
    };

    const validatePerCentageOilTopRatio = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, oilTopupRatio: false }));
            return;
        }
        const regex = /^\d{1,10}(\.\d{1,})?$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, oilTopupRatio: !isValid }));
    }

    const validateWaterUsed = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, waterUsed: false }));
            return;
        }
        const regex = /^\d{1,10}(\.\d{1,})?$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, waterUsed: !isValid }));
    }
    return (
        <div>
            <Modal isOpen={modal} toggle={toggleModal} {...args} modalClassName="custom-modal">
                <h1 style={{ textAlign: 'center', borderBottom: '4px solid rgb(14, 61, 13)', color: 'rgb(14, 61, 13)' }} className="m-3">
                    {
                        isViewOnly ? 'View Machine' : 'Update Machine'
                    }
                </h1>
                <ModalBody>
                    <Form>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="machineName">Machine Name<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="machineName"
                                        name="machineName"
                                        placeholder="Enter Machine Name"
                                        type="text"
                                        value={machineName}
                                        invalid={formError.machineName}
                                        onChange={(e) => {
                                            setMachineName(e.target.value)
                                            validateMachineName(e)
                                        }}
                                        // disabled={isViewOnly}
                                        disabled
                                        maxLength={20}
                                    />
                                    <FormFeedback>MachineName must only contain alphabets.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="machineModel">Model/Cell<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="machineModel"
                                        name="machineModel"
                                        placeholder="Enter Machine Model"
                                        type="text"
                                        value={machineModel}
                                        invalid={formError.model}
                                        onChange={(e) => {
                                            setMachineModel(e.target.value)
                                            validateModel(e)
                                        }}
                                        // disabled
                                        maxLength={15}
                                    />
                                    <FormFeedback>Model must only contain alphabets.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="machineSize">Machine Size/Line No<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="machineSize"
                                        name="machineSize"
                                        placeholder="Enter Machine Size"
                                        type="text"
                                        value={machineSize}
                                        invalid={formError.machineSize}
                                        onChange={(e) => {
                                            setMachineSize(e.target.value)
                                            validateMachineSize(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={15}
                                    />
                                    <FormFeedback>Machine Size should be only contain number</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="machineNumber">Machine Number<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="machineNumber"
                                        name="machineNumber"
                                        type="text"
                                        placeholder='Enter machine number (Should be unique)'
                                        value={machineNumber}
                                        invalid={formError.machineNumber}
                                        onChange={(e) => {
                                            setMachineNumber(e.target.value)
                                            validateMachineNumber(e)
                                        }}
                                        // disabled={isViewOnly}
                                        disabled
                                        maxLength={15}

                                    />
                                    <FormFeedback>Machine Number must contain only letters and numbers.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="companySelect">Select Company<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="select"
                                        name="selectCompany"
                                        id="companySelect"
                                        value={companyName}
                                        onChange={(e) => {
                                            setCompanyName(e.target.value);
                                            setCoolant("");
                                            setHydraulicOil("");
                                            setMaintanceOil("")
                                        }}
                                        // disabled={isViewOnly}
                                        disabled={isViewOnly}
                                    >
                                        <option value="">Select company</option>
                                        {companyList.map((item) => (
                                            <option key={item?.id} value={item?.id}>{item?.company_name}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="coolant">Select Coolant<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="select"
                                        name="coolant"
                                        id="coolant"
                                        value={coolant}
                                        onChange={(e) => {
                                            setCoolant(e.target.value)
                                            setFormError(prevState => ({ ...prevState, coolantOil: false }));
                                        }}
                                        disabled={isViewOnly}
                                        invalid={formError.coolantOil}
                                    >
                                        <option value="">Select Coolant</option>
                                        {coolantList.map((item) => (
                                            <option key={item?.oil_id} value={item?.oil_id}>{item?.brand_name} ({item?.product_name})</option>
                                        ))}
                                    </Input>
                                    <FormFeedback>Select coolant oil.</FormFeedback>
                                </FormGroup>

                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="maintanceoil">Select Neat Oil</Label>
                                    {/* <Label for="maintanceoil">Select Neat Oil</Label> */}
                                    <Input
                                        type="select"
                                        name="maintanceoil"
                                        id="maintanceoil"
                                        value={maintanceOil}
                                        invalid={formError.maintanceOil}
                                        onChange={(e) => {
                                            setMaintanceOil(e.target.value)
                                            setFormError(prevState => ({ ...prevState, maintanceOil: false }));
                                        }}
                                        disabled={isViewOnly}
                                    >
                                        <option value="">Select Neat Oil</option>
                                        {maintanceOilList.map((item) => (
                                            <option key={item?.oil_id} value={item?.oil_id}>{item?.brand_name} ({item?.product_name})</option>
                                        ))}
                                    </Input>
                                    <FormFeedback>Select Neat oil.</FormFeedback>
                                    {/* <FormFeedback>Select Neat Oil</FormFeedback> */}
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="Hydraulicoil">Select Hydraulic Oil</Label>
                                    <Input
                                        type="select"
                                        name="Hydraulicoil"
                                        id="Hydraulicoil"
                                        value={hydraulicOil}
                                        invalid={formError.hydraulicOil}
                                        onChange={(e) => {
                                            setHydraulicOil(e.target.value)
                                            setFormError(prevState => ({ ...prevState, hydraulicOil: false }));
                                        }}
                                        disabled={isViewOnly}
                                    >
                                        <option value="">Select Hydraulic Oil</option>
                                        {hydraulicOilList.map((item) => (
                                            <option key={item?.oil_id} value={item?.oil_id}>{item?.brand_name} ({item?.product_name})</option>
                                        ))}
                                    </Input>
                                    <FormFeedback>Select hydraulic oil.</FormFeedback>
                                </FormGroup>

                            </Col>
                        </Row>

                        <Row>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="tankSize">Tank Size<span style={{ color: 'red' }}>*</span></Label>

                                    <Input
                                        id="tankSize"
                                        name="tankSize"
                                        placeholder="Enter Tank Size"
                                        type="number"
                                        value={tankSize}
                                        invalid={formError.tankSize}
                                        onChange={(e) => {
                                            setTankSize(e.target.value)
                                            validateTankSize(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={15}
                                    />
                                    <FormFeedback>TankSize must contain only letters and numbers.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>

                                    <Label for="selectuser">Select Users<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="text"
                                        id="searchInput"
                                        value={searchData}
                                        onChange={handleUserSearch}
                                        placeholder="Search user by their name..."
                                        disabled={isViewOnly}
                                        invalid={formError.selectedUsers}


                                    />
                                    <div style={{ maxHeight: '125px', overflowY: 'auto', border: '1px solid #ced4da', padding: '10px' }} className='rounded '>

                                        {filteredUser.map((item) => (
                                            <CustomInput
                                                key={item?.uuid}
                                                type="checkbox"
                                                id={item?.uuid}
                                                label={`${item?.first_name} ${item?.last_name}`}
                                                value={item?.uuid}
                                                checked={selectedUsers.includes(item?.uuid)}
                                                onChange={handleUserSelection}
                                                className='m-1'
                                            // disabled={isViewOnly || item?.iseditable}
                                            />
                                        ))}
                                    </div>
                                    <FormFeedback>Select user.</FormFeedback>

                                </FormGroup>
                            </Col>
                        </Row>



                        <Row>
                            <Col md={6}>
                                {/* <FormGroup>
                                    <Label for="concentration">Concentration Parameters*</Label>
                                    <div>
                                        <Button
                                            color={concentrationParameters === 'lower' ? 'primary' : 'secondary'}
                                            onClick={() => handleConcentrationChange('lower')}
                                            disabled={isViewOnly}
                                        >
                                            Lower
                                        </Button>
                                        <Button
                                            color={concentrationParameters === 'higher' ? 'primary' : 'secondary'}
                                            onClick={() => handleConcentrationChange('higher')}
                                            style={{ marginLeft: '10px' }}
                                            disabled={isViewOnly}
                                        >
                                            Higher
                                        </Button>
                                    </div>
                                </FormGroup>
                            </Col> */}
                                <FormGroup>
                                    <Label for="lowercp">Lower Concentration Parameter<span style={{ color: 'red' }}>*</span></Label>

                                    <Input
                                        id="lowercp"
                                        name="lowercp"
                                        placeholder="Enter Lower Concentration Parameter"
                                        type="number"
                                        value={lowerCP}
                                        invalid={formError.lowerCP}
                                        onChange={(e) => {
                                            setLowerCP(e.target.value)
                                            validateLowerCP(e)
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                            }
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={2}
                                    />
                                    {/* <FormFeedback>Lower Concentration Parameter must contain only letters and numbers.</FormFeedback> */}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="highercp">Higher Concentration Parameter<span style={{ color: 'red' }}>*</span></Label>

                                    <Input
                                        id="highercp"
                                        name="highercp"
                                        placeholder="Enter Higher Concentration Parameter"
                                        type="number"
                                        value={higherCP}
                                        invalid={formError.higherCp}
                                        onChange={(e) => {
                                            setHigherCP(e.target.value)
                                            validateHigherCP(e)
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                            }
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={2}
                                    />
                                    {/* <FormFeedback>Higher Concentration Parameter must contain only letters and numbers.</FormFeedback> */}
                                </FormGroup>
                                {/* <Col md={6}> */}

                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="potr">Percentage Oil Top-up Ratio <span style={{ color: 'red' }}>*</span></Label>

                                    <Input
                                        id="potr"
                                        name="potr"
                                        placeholder="Enter % Oil Top Up Ratio "
                                        type="number"
                                        value={perCentageOilTopRatio}
                                        invalid={formError.perCentageOilTopRatio}
                                        onChange={(e) => {
                                            setPercentageOilTopRatio(e.target.value)
                                            validatePerCentageOilTopRatio(e)
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                            }
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={10}
                                    />
                                    {/* <FormFeedback>Percentage Oil Top-up Ratio must contain only letters and numbers.</FormFeedback> */}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="waterused">Water Used <span style={{ color: 'red' }}>*</span></Label>

                                    <Input
                                        id="waterused"
                                        name="waterused"
                                        placeholder="Enter Water Used Value"
                                        type="text"
                                        value={waterUsed}
                                        invalid={formError.waterUsed}
                                        onChange={(e) => {
                                            setWeaterUsed(e.target.value)
                                            validateWaterUsed(e)
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                            }
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={10}
                                    />
                                    {/* <FormFeedback>Water Used must contain only letters and numbers.</FormFeedback> */}
                                </FormGroup>

                            </Col>
                        </Row>
                        <FormGroup>
                            <Label for="statusSelect">Status</Label>
                            <CustomInput
                                type="switch"
                                id="statusSelect"
                                name="status"
                                label={status ? 'Active' : 'Inactive'}
                                checked={status}
                                onChange={handleStatusChange}
                                disabled={isViewOnly}
                            />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    {
                        isViewOnly ? '' :

                            <Button className="btn-primary" onClick={handleFormSubmit} disabled={loading}>
                                {loading ? <Spinner size="sm" /> : 'Update Machine'}
                            </Button>
                    }
                    <Button color="secondary" onClick={toggleModal} style={isViewOnly ? { outline: 'none', boxShadow: 'none', backgroundColor: 'rgb(14, 61, 13)', color: 'white' } : {}}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default UpdateViewMachine;
